module.exports = __webpack_public_path__ + "static/media/Plus.d69a3633.svg";